import styled from 'styled-components';
import { hexToRGB, typography } from '@/styles/helpers';

export const ScCouponPrefilledNotice = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 608px;
  width: 100%;
  margin: 0 auto -12px;
  padding: 8px 16px;
  border-radius: 16px;
  background-color: ${({ theme }) => hexToRGB(theme.greenSuccessColor, 0.2)};

  .notice {
    ${typography.body2regular};
    color: ${({ theme }) => theme.whiteColor};

    span {
      font-weight: 700;
    }
  }
`;
